import { MARKET_STATUS_POLLING_INTERVAL } from "~/v2/constants";
import { queryKeys } from "../queryKeys";
import { getMarketStatus, type MarketStatus } from "../rest/data";
import useRequest, { type QueryOptions } from "./useRequest";

type UseGetMarketStatusArgs = {
  market?: string;
  options?: QueryOptions<MarketStatus>;
};

export const useGetMarketStatus = ({
  market = "NMS",
  options,
}: UseGetMarketStatusArgs = {}) => {
  const { data: marketStatus, ...rest } = useRequest(
    queryKeys.marketStatus(market),
    () => getMarketStatus(market),
    {
      staleTime: 0,
      gcTime: 0,
      refetchInterval: MARKET_STATUS_POLLING_INTERVAL,
      ...options,
    },
  );

  return { marketStatus, ...rest };
};

export default useGetMarketStatus;
